import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import "datatables.net";
import "datatables.net-dt/css/dataTables.dataTables.css";
import { ProtectAPi } from "../../../api/ProtectAPi";
import AdminQuickNav from "./AdminQuickNav";

const InterestList = () => {
  const { http } = ProtectAPi();
  const tableRef = useRef(null);
  const dataTableInstance = useRef(null);
  const [data, setData] = useState([]);

  /* ================= FETCH ================= */
  useEffect(() => {
    fetchInterests();
  }, []);

  const fetchInterests = async () => {
    try {
      const res = await http.get("/interest-list");
      setData(res.data.data || []);
    } catch (e) {
      console.error("Interest fetch error", e);
      setData([]);
    }
  };

  /* ================= DATATABLE ================= */
  useEffect(() => {
    $.fn.dataTable.ext.errMode = "none";

    if (dataTableInstance.current) {
      $(dataTableInstance.current).DataTable().destroy();
      dataTableInstance.current = null;
    }

    if (data.length > 0) {
      dataTableInstance.current = $(tableRef.current).DataTable({
        paging: true,
        searching: true,
        ordering: true,
        info: true,
        pageLength: 10, 
      });
    }
    

    return () => {
      if (dataTableInstance.current) {
        $(dataTableInstance.current).DataTable().destroy();
      }
    };
  }, [data]);

  return (
    <div className="main-content" style={{ marginTop: -20 }}>
      <section className="section">
        <AdminQuickNav active="interest" />

        <div className="card">
          <div className="card-body">
            <h5 className="fw-bold mb-3">Interest List</h5>

            <div className="table-responsive">
              <table
                className="table table-striped table-bordered"
                ref={tableRef}
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Phone</th>
                    <th>Email</th>
                    <th>Interest</th>
                    <th>Date</th>
                  </tr>
                </thead>

                <tbody>
                  {data.map((item, index) => (
                    <tr key={item.id}>
                      <td>{index + 1}</td>
                      <td>{item.name}</td>
                      <td>{item.phone}</td>
                      <td>{item.email || "—"}</td>
                      <td>{item.interest}</td>
                        <td>
                            {new Date(item.created_at).toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                            })}
                        </td>

                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default InterestList;
